// extracted by mini-css-extract-plugin
export default {"container":"CriteriaPanel_container__9V-Hr","list":"CriteriaPanel_list__AGQgk","main":"CriteriaPanel_main__2tu1a"};